(function () {
  function initVariantGallery() {
    const gallery = document.querySelector('.product-media-gallery, [data-media-gallery], .media-gallery');
    if (!gallery) return;

    const productJson = document.getElementById('ProductJson') || document.querySelector('[id^="ProductJson"]') || document.querySelector('script[type="application/json"][data-product-json]');
    if (!productJson) return;

    let product;
    try { product = JSON.parse(productJson.textContent); } catch (e) { return; }

    const variants = product.variants;
    const mediaItems = gallery.querySelectorAll('[data-media-id], .product-media-gallery__item, li.media-gallery__item, .media-gallery__item');

    if (!mediaItems.length) return;

    const mediaMap = {};
    mediaItems.forEach(item => {
      const id = item.dataset.mediaId || item.getAttribute('data-media-id');
      if (id) mediaMap[id] = item;
    });

    const variantMediaMap = {};
    variants.forEach(v => {
      if (v.featured_media) variantMediaMap[v.id] = String(v.featured_media.id);
    });

    function showOnlyMedia(mediaId) {
      mediaItems.forEach(item => {
        const id = item.dataset.mediaId || item.getAttribute('data-media-id');
        item.style.display = (id === mediaId) ? '' : 'none';
      });
    }

    function onVariantChange(variantId) {
      const mediaId = variantMediaMap[variantId];
      if (mediaId) showOnlyMedia(mediaId);
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) onVariantChange(e.detail.variant.id);
    });

    document.querySelectorAll('select[name="id"], input[name="id"]').forEach(el => {
      el.addEventListener('change', function () {
        onVariantChange(parseInt(this.value));
      });
    });

    document.addEventListener('change', function(e) {
      if (e.target && e.target.closest('variant-radios, variant-selects, .variant-picker')) {
        const form = e.target.closest('form');
        if (!form) return;
        const idInput = form.querySelector('[name="id"]');
        if (idInput) onVariantChange(parseInt(idInput.value));
      }
    });

    const firstVariant = variants[0];
    if (firstVariant && variantMediaMap[firstVariant.id]) {
      showOnlyMedia(variantMediaMap[firstVariant.id]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantGallery);
  } else {
    initVariantGallery();
  }
})();
